module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "als"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "fmhT"
  }, [_vm._v("ALSO BY PENNY VINCENZI")]), _vm._v(" "), _c('div', {
    staticClass: "ctag1"
  }, [_c('i', [_vm._v("No Angel")])]), _vm._v(" "), _c('div', {
    staticClass: "ctag1"
  }, [_c('i', [_vm._v("Something Dangerous")])]), _vm._v(" "), _c('div', {
    staticClass: "ctag1"
  }, [_c('i', [_vm._v("Almost a Crime")])]), _vm._v(" "), _c('div', {
    staticClass: "ctag1"
  }, [_c('i', [_vm._v("The Dilemma")])]), _vm._v(" "), _c('div', {
    staticClass: "ctag1"
  }, [_c('i', [_vm._v("An Outrageous Affair")])]), _vm._v(" "), _c('div', {
    staticClass: "ctag1"
  }, [_c('i', [_vm._v("Sheer Abandon")])]), _vm._v(" "), _c('div', {
    staticClass: "ctag1"
  }, [_c('i', [_vm._v("An Absolute Scandal")])]), _vm._v(" "), _c('div', {
    staticClass: "ctag1"
  }, [_c('i', [_vm._v("Forbidden Places")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f49accb","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/vinc_9781590208007_oeb_als_r1.vue
// module id = 66
// module chunks = 0